import { translation } from 'easit--localization'
import React from 'react'
import { getMaxWidthOfLiveStreamForCss } from './betradarVideoPlayer';

export const LiveStreamLoader = () => {
    return <div style={{ maxWidth: getMaxWidthOfLiveStreamForCss(), margin: "auto", height: "100px", textAlign: "center" }}>{translation().general_Loading}</div>
}